import script from "./ThreeDmodels.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeDmodels.vue?vue&type=script&setup=true&lang=js"

import "./ThreeDmodels.vue?vue&type=style&index=0&id=53e77666&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e77666"]])

export default __exports__